import { useQuery } from '@tanstack/react-query';

import { SAMLConfig } from '@graylog/enterprise-api';

type DefaultAttributeMapping = {
  user_name: string[];
  email: string[];
  first_name: string[];
  last_name: string[];
  full_name: string[];
};

const useSAMLDefaultAttributeMapping = (): { isLoading: boolean; defaultAttributeMapping: DefaultAttributeMapping } => {
  const { isLoading, isError, data } = useQuery({
    queryKey: ['saml.default.attribute.mapping'],

    queryFn: () => SAMLConfig.getIdpDefaultAttributeMapping(),
  });

  if (isError) {
    return {
      isLoading: false,
      defaultAttributeMapping: undefined,
    };
  }

  return {
    isLoading: isLoading,
    defaultAttributeMapping: data,
  };
};

export default useSAMLDefaultAttributeMapping;
